import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';

// Reactive Form
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

// App routing modules
import { AppRoutingModule } from './shared/routing/app-routing.module';

// App components
import { AppComponent } from './app.component';
import { SignInComponent } from './components/sign-in/sign-in.component';
import { SignUpComponent } from './components/sign-up/sign-up.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { VerifyEmailComponent } from './components/verify-email/verify-email.component';

// Firebase services + enviorment module
import { AngularFireModule } from "@angular/fire";
import { AngularFireAuthModule } from "@angular/fire/auth";
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { environment } from '../environments/environment';

// Auth service
import { AuthService } from "./shared/services/auth.service";

// Page Components
import { NotFoundComponent } from './components/not-found/not-found.component';
import { EmployeesComponent } from './components/employees/employees.component';
import { InboxComponent } from './components/inbox/inbox.component';
import { ChatRoomComponent } from './components/chat-room/chat-room.component';
import { CalenderComponent } from './components/calender/calender.component';
import { HelpCentreComponent } from './components/help-centre/help-centre.component';
import { SettingsComponent } from './components/settings/settings.component';
// Admin Page
import { AdminDashboardComponent } from './components/admin-dashboard/admin-dashboard.component';

// PrimeNG Components
import { FullCalendarModule } from 'primeng/fullcalendar';
import {ChartModule} from 'primeng/chart';
import {AccordionModule} from 'primeng/accordion';
import {DialogModule} from 'primeng/dialog';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import {MenuModule, MenuItemContent} from 'primeng/menu';
import {FileUploadModule} from 'primeng/fileupload';


// FaceRecognition
import { BoolToYesNoPipe } from './shared/bool-to-yes-no/bool-to-yes-no.pipe';
import { DesktopCameraService } from './shared/services/desktop-camera.service';
import { FaceRecognitionService } from './shared/services/face-recognition.service';

@NgModule({
  declarations: [
    AppComponent,
    SignInComponent,
    SignUpComponent,
    DashboardComponent,
    ForgotPasswordComponent,
    VerifyEmailComponent,
    NotFoundComponent,
    EmployeesComponent,
    InboxComponent,
    ChatRoomComponent,
    CalenderComponent,
    HelpCentreComponent,
    SettingsComponent,
    AdminDashboardComponent,
    BoolToYesNoPipe
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAuthModule,
    AngularFirestoreModule,
    AngularFirestoreModule.enablePersistence(),
    FormsModule,
    ReactiveFormsModule,
    FullCalendarModule,
    HttpClientModule,
    BrowserAnimationsModule,
    ChartModule,
    AccordionModule,
    DialogModule,
    ProgressSpinnerModule,
    MenuModule,
    FileUploadModule,
  ],
  providers: [
    AuthService, 
    DesktopCameraService,
    DesktopCameraService,
    FaceRecognitionService,
  ],
  bootstrap: [AppComponent]
})

export class AppModule { }